import { useMutation } from "@tanstack/react-query";

import Sentry from "@similarweb/sentry-logger";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

export const useUpdateMessage = () => {
    return useMutation({
        mutationFn: async (params: { threadId: string; messageId: string; message: string }) => {
            await salesApiService.aiAgent.superAgent.updateMessage(params);
        },
        onError: (error) => {
            Sentry.errorTracker({
                e: error,
                message: "Failed to update super agent message with email threadId",
                level: "error",
            });
        },
    });
};
